module.exports = __webpack_public_path__ + "static/wps-01842cc55ef06de4c59002f7ea1ccdbd.png";